<div class="backup-code">
  <div class="title">
    <h1>
      {{ "SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.BACKUPCODE.TITLE" | translate }}
    </h1>
    <p>
      {{ "SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.BACKUPCODE.SUB_TITLE" | translate }}
    </p>
  </div>
  <div class="backup-code-content">
    <div class="icon">
      <div
        class="circle-ripple"
        [ngClass]="{
          error: (errorState$ | async)?.message,
          success: (successState$ | async)
        }"
      >
        <span class="cidaas-icon-backupcode"></span>
      </div>
    </div>
    <div class="status">
      <span class="error" *ngIf="(errorState$ | async)?.message">{{
        ((errorState$ | async)?.message || "") | translate:{tr_fallback: ((errorState$ | async)?.default_message || "ERROR_OCCURRED") | translate}
      }}</span>

      <span class="success" *ngIf="successState$ | async"
        >{{"SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.BACKUPCODE.SUCCESS" | translate}}</span
      >

    </div>
  </div>
</div>

<!-- if backup codes are generated will show it here -->
<ng-container *ngIf="successState$ | async">
  <ng-container *ngTemplateOutlet="backupCodes"></ng-container>
</ng-container>

<ng-container *ngIf="(errorState$ | async)?.message">
  <span style="padding: 1.5rem 0">
    <a
      *ngIf="(errorState$ | async)?.message"
      (click)="_backToSuggestVerificationList('error')"
      >{{ "Back" | translate }}</a
    ></span
  >
</ng-container>



<!-- template for the button group -->
<ng-template #btnGroup>
  <div class="btn-wrapper">
    <div class="btngroup">
      <cid-button [btnOption]="continueBtnOptions" (clickEvent)="_backToSuggestVerificationList('completed')"></cid-button>
    </div>
  </div>
</ng-template>

<!-- template for the display name -->
<ng-template #backupCodes>
  <div class="wrapper">
    <div
      style="
        float: left;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      "
    >
      <div class="backupCode">
        <h3>{{ "SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.BACKUPCODE.USAGE_INSTRUCTION" | translate }}</h3>
        <ul *ngIf="backupCodes$ | async" class="backupCodes">
          <li class="code" *ngFor="let item of (backupCodes$ | async)">{{item['code']}}</li>
        </ul>
        <ng-container *ngTemplateOutlet="btnGroup"></ng-container>
      </div>
    </div>
  </div>
</ng-template>
